import { render, staticRenderFns } from "./expandContractAmount.vue?vue&type=template&id=21c1c413"
import script from "./expandContractAmount.vue?vue&type=script&lang=js"
export * from "./expandContractAmount.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports